// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'graduate';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.938 4.5a3.937 3.937 0 1 1-7.876 0V.562h7.875zM1.688 17.438a7.312 7.312 0 1 1 14.624 0M.563.563h16.875M5.063 3.938h7.875M1.688.563v5.625' />
    <path d='M5.26 11.153 9 14.063l3.74-2.91' />
  </g>
);

export const viewBox = '0 0 18 18';
